import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { TaskService } from '..';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {TaskComponent} from '@app/_components/task/task/task.component';

@Component({
    selector: 'app-task-folder-nav',
    templateUrl: './task-folder-nav.component.html',
    styleUrls: ['./task-folder-nav.component.css'],
    standalone: false
})
export class TaskFolderNavComponent implements OnInit, OnChanges {

	@Input() tagId: number;
	@Input() users: any[] = [];
	@Output() eventTagSelect = new EventEmitter<any>();
	@Output() eventPeopleSelect = new EventEmitter<any>();
	tags: TreeNode[] = [];
  baseTags: TreeNode[] = [];
  peopleIcon = 'pi pi-users';
	loading = false;
	menuItems: any[];
  folderType = {
    1: {'icon':'pi pi-folder',       'styledata' : 'background:#ffffff; color: #de880b', 'name': 'folder'},
    2: {'icon':'pi pi-chart-pie',    'styledata' : 'background:#ffffff; color: #547253', 'name': 'context'},
    3: {'icon':'pi pi-clock',        'styledata' : 'background:#ffffff; color: #ff0048', 'name': 'goal'},
    4: {'icon':'pi pi-tag',          'styledata' : 'background:#ffffff; color: #123a8d', 'name': 'tag'},
    5: {'icon':'pi pi-server',       'styledata' : 'background:#ffffff; color: #e00665', 'name': 'project'},
    6: {'icon':'pi pi-fast-forward', 'styledata' : 'background:#ffffff; color: #79792e', 'name': 'phase'},
    7: {'icon':'pi pi-list',         'styledata' : 'background:#ffffff; color: #05788c', 'name': 'process'}
  };
  selectedNode: any;
  peopleSearch: string = '';

	constructor(
		private taskService: TaskService,
		public messageService: MessageService,
		private dialog: MatDialog,
	) { }


	ngOnInit(): void {
		let taskTag = { tagId: this.tagId };
    	this.constructBaseFolders();
		this.fetchFolderNav(taskTag);
		this.menuItems = [
      {
        label: 'Task',
        icon: 'pi pi-fw pi-plus',
        command: (event) => this.openCreateTaskPlain()
      },
      {
        label: 'Defect',
        icon: 'pi pi-fw pi-plus',
        command: (event) => this.openCreateTask(142)
      },
      {
        label: 'Feature',
        icon: 'pi pi-fw pi-plus',
        command: (event) => this.openCreateTask(107)
      }
		];
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['users'] && this.baseTags.length > 0) {
			this.buildCombinedTags();
		}
	}

	private buildPeopleNode(): TreeNode {
		const query = (this.peopleSearch || '').toLowerCase().trim();
		const filteredUsers = (this.users || []).filter(user => {
			if (!query) return true;
			const first = (user?.firstName || '').toLowerCase();
			const last = (user?.lastName || '').toLowerCase();
			const full = (user?.fullName || '').toLowerCase();
			return first.includes(query) || last.includes(query) || full.includes(query);
		});
		const childNodes: TreeNode[] = filteredUsers.map(user => ({
			label: user?.fullName || [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim() || 'Unknown',
			data: { ...user, isUser: true },
			leaf: true,
			icon: '',
			expandedIcon: '',
			collapsedIcon: ''
		}));
		return {
			label: 'People',
			data: { isPeopleFolder: true },
			expandedIcon: '',
			collapsedIcon: '',
			children: childNodes,
			expanded: false,
			style: 'color: #06465B'
		};
	}

	onPeopleSearchChange(): void {
		this.buildCombinedTags();
		// Keep People node expanded when searching
		if (this.tags.length > 0 && this.peopleSearch) {
			this.tags[0].expanded = true;
		}
	}

	private buildCombinedTags(): void {
		const peopleNode = this.buildPeopleNode();
		this.tags = [peopleNode, ...this.baseTags];
	}

	openCreateTask(taskType: any) {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '100vw';
		dialogConfig.height = '100vh';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.maxHeight = '100vh';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Task',
			isModal: true,
      selectedTagForCreate: this.selectedNode,
      taskTypeCategory: taskType
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);
			});
	}
  openCreateTaskPlain() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add Task',
      isModal: true,
      selectedTagForCreate: this.selectedNode
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
      });
  }
  constructBaseFolders(){
    for (let i  = 1 ; i < 8; i++){
      let folder: TreeNode<any> = {};
      folder.expandedIcon = this.folderType[i]?.['icon'];
      folder.collapsedIcon = this.folderType[i]?.['icon'];
      folder.style = this.folderType[i]?.['styledata'];
      folder.label = this.folderType[i]?.['name'];
      folder.children = [];
      this.baseTags.push(folder);
    }
  }
	nodeExpand(event) {
    return;
		if (event.node) {
			console.log(event.node);
			this.loading = true;
			let taskTag = { tagId: event.node.data };
			this.taskService.getFolderNav(taskTag).pipe(first()).subscribe(
				res => {
					// console.log('reports are: ' + JSON.stringify(data));
					event.node.children = res.data.tags;
					console.log('folders ' + JSON.stringify(res.data.tags));
					this.loading = false;
				},
				err => {
					// console.log('user-select ERROR: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					this.loading = false;
				},
				() => { this.loading = false; }
			);
		}
	}

	onNodeSelect(node: TreeNode) {
		if (node?.data?.isUser) {
			this.eventPeopleSelect.emit(node.data);
		} else if (node?.data && !node.data.isPeopleFolder) {
			this.eventTagSelect.emit(node.data);
		}
	}

	fetchFolderNav(taskTag: any): void {
    this.loading = true;
		this.taskService.getFolderNav(taskTag).pipe(first()).subscribe(
			res => {
			this.tags = res.data.tags;
			let temptags: TreeNode[] = [];
			let folder: TreeNode<any> = {};
			temptags.push(folder);
			let folderchildren: TreeNode[] = [];
			folder.children = folderchildren;
			this.tags.forEach(tag => {
				tag.icon = '';
				tag.collapsedIcon = '';
				tag.expandedIcon = '';
			  this.baseTags[tag?.data?.tagType - 1].children.push(tag);
			});
			this.buildCombinedTags();
		},
			err => {
				// console.log('user-select ERROR: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
			},
			() => {this.loading = false; }
		);
	}
	openCm(event, cm, node) {
		event.preventDefault();
		event.stopPropagation();
		cm.show(event);
		this.selectedNode = node;
		return false;
	}
}
